import React, { forwardRef } from "react";
import { TarifficationMWrapper } from "ComponentsUI/TarifficationM";
import MobileTariffRowContainer from "Containers/MobileTariffRowContainer";
import { DeclinationsOfferedInfo } from "ComponentsUI/InfoBlocks";

const MobileTariffList = forwardRef((props, ref) => {
	const { tariffs, simCards, thisOfferedTariff, declinationsName, text } = props;

	return (
		<>
			{!!thisOfferedTariff && (
				<DeclinationsOfferedInfo declinationsName={declinationsName} text={text} />
			)}
			<TarifficationMWrapper text={text} ref={ref}>
				{tariffs.map((item, index) => {
					return (
						<MobileTariffRowContainer
							tariff={item}
							key={item.id}
							simCards={simCards}
							isAction={props.isAction}
							isRatesMobileRegion={props.isRatesMobileRegion}
							transfer={props.transfer}
						/>
					);
				})}
			</TarifficationMWrapper>
		</>
	);
});

export default MobileTariffList;
